import { Component, OnInit } from '@angular/core';
import { ServiceDataSource } from 'maestro-ng';
import { environment } from '../../../environments/environment';
import { appConstants } from '../../app.constants';
import { AppService } from '../../app.service';
import { Sistema } from '../../monitoramento/sistema.model';
import { AplicacaoDados } from '../aplicacao-dados.model';

@Component({
  selector: 'app-aplicacao-dados',
  templateUrl: './aplicacao-dados.component.html',
  styleUrls: ['./aplicacao-dados.component.css'],
})
export class AplicacaoDadosComponent implements OnInit {
  ds: ServiceDataSource<AplicacaoDados, number>;
  aplicacaoDados: AplicacaoDados;
  aplicacaoDadosSistema: Sistema;

  public aplicacao: {
    nome: string;
    versao: string;
    commitSha: string;
    dataCompilacao: string;
  };

  constructor(private service: AppService) {}

  ngOnInit(): void {
    this.service.recuperarDados().then((dados) => {
      if (dados) {
        this.aplicacaoDados = dados;
      }
    });
    this.service.recuperarDadosSistema().then((sistema) => {
      if (sistema) {
        this.aplicacaoDadosSistema = sistema;
      }
    });
    this.aplicacao = {
      nome: appConstants.nome,
      versao: environment.versao,
      dataCompilacao: environment.dataCompilacao,
      commitSha: environment.commitSha,
    };
  }
}
